/**
 * These are all player functions related to the API
 */

/**
 * This is the PUBLIC Api key to streamspot
 * @type {String}
 */
const APIKEY = '73d4c9e8-2320-4800-a379-6ef591eae4c1'
let APIURI = 'https://live-api.prod.subsplash.io'
if (window.location.hostname.includes('testing') || window.location.hostname.includes('stage') || window.location.hostname.includes('sandbox') || window.location.hostname.includes('localhost')) {
  console.log('Testing URL detected; using stage API');
  APIURI = 'https://live-api.stage.subsplash.io'
}

var _ = require('lodash')

/**
 * Gets all the videos for the player
 * @param  {[type]}   context player context
 * @param  {Function} cb 	  callback
 * @return {[type]}           [description]
 */
function getVideos(ssId, cb) {
  $.get(`${APIURI}/broadcaster/${ssId}/videos?lifecycle=current&apiKey=${APIKEY}`, function(response) {
    cb(response.data)
  })
}

/**
 * Gets all the videos for the player
 * @param  {[type]}   context player context
 * @param  {Function} cb 	  callback
 * @return {[type]}           [description]
 */
function getVideosByCategory(ssId, category, cb) {
  $.get(`${APIURI}/broadcaster/${ssId}/videos/category/${category}?lifecycle=current&apiKey=${APIKEY}`, function(response) {
    cb(response.data)
  })
}

/**
 * Get one video by idHash
 * @param  {[type]}   id [description]
 * @param  {Function} cb [description]
 * @return {[type]}      [description]
 */
function getVideo(id, cb) {
  var url = `${APIURI}/video/${id}?apiKey=${APIKEY}`;
  $.get(`${APIURI}/video/${id}?apiKey=${APIKEY}`, function(response) {
    console.log(url);
    cb(response.data.video)
  })
}

/**
 * Get the meta object for the player
 */
function getMeta(playerId, cb) {
  $.get(`${APIURI}/player/${playerId}/meta?apiKey=${APIKEY}`, function(response) {
    var meta = response.data.meta
    meta = _.mapValues(meta, function(n) {
      if(n === '1' || n === '0') return parseInt(n)
      return n
    })
    cb(meta)
  })
}

/**
 * Get the meta object for a player based on broadcastor
 */
function getMetaByBroadcastor(ssId, cb) {
  $.get(`${APIURI}/broadcaster/${ssId}/player/meta?apiKey=${APIKEY}`).done(function(response) {
    var meta = response.data.meta
    meta = _.mapValues(meta, function(n) {
      if(n === '1' || n === '0') return parseInt(n)
      return n
    })
    cb(meta)
  }).fail(function(){
    cb(null)
  })
}

/**
 * Get the meta object for the player
 */
function getBroadcaster(id, cb) {
  $.get(`${APIURI}/broadcaster/${id}/cached?apiKey=${APIKEY}`, function(response) {
    var broadcaster = response.data.broadcaster
    broadcaster = _.mapValues(broadcaster, function(n) {
      if(n === '1' || n === '0') return parseInt(n)
      return n
    })
    cb(broadcaster)
  })
}

/**
 * Get all the broadcaster's upcoming broadcasts
 * @param  {[type]}   context player context
 * @param  {Function} cb 	  callback
 * @return {[type]}           [description]
 */
function getUpcomingBroadcasts(ssId, cb) {
  $.get(`${APIURI}/broadcaster/${ssId}/broadcasts/upcoming?apiKey=${APIKEY}`, function(response) {
    cb(response.data)
  })
}


function eventAuth(eventId, passcode, cb) {
  $.get(`${APIURI}/event/${eventId}/auth?passcode=${passcode}&apiKey=${APIKEY}`, function(response) {
    cb(response.data.lock)
  }).fail(function(){
    cb(null)
  })
}

/**
 * Authenticate video
 * @param  {string}   id       idHash of video
 * @param  {string}   passcode The passcode the user submitted
 * @param  {Function} cb       callback
 * @return {boolean}           The result of the auth call
 */
function videoAuth(id, passcode, cb) {
  $.get(`${APIURI}/video/${id}/auth?passcode=${passcode}&apiKey=${APIKEY}`, function(response) {
    cb(response.data.lock)
  })
}


/**
 * Check if the broadcaster is broadcasting
 * @param  {[type]}   context player context
 * @param  {Function} cb 	  callback
 * @return {[type]}           [description]
 */
function checkisBroadcasting(ssId, cb) {
  $.get(`${APIURI}/broadcaster/${ssId}/broadcasting?apiKey=${APIKEY}`, function(response) {
    cb(response.data.isBroadcasting)
  })
}

function checkIsLocked(ssId, cb) {
  $.get(`${APIURI}/v2/broadcaster/${ssId}/isLocked?apiKey=${APIKEY}`, function(response) {
    cb(response.data.lock)
  })
}

/**
 * Makes an API call to get a broadcaster's categories
 * @param  {string}   ssId ssId of broadcaster
 * @param  {Function} cb         callback
 * @return {array}               Array of categories
 */
function getCategories(ssId, cb) {
  $.get(`${APIURI}/broadcaster/${ssId}/categories?apiKey=${APIKEY}`, function(response) {
    cb(response.data.categories)
  })
}

function getBranding(brandingId, cb) {
  $.get(`${APIURI}/branding/getBranding/${brandingId}?apiKey=${APIKEY}`, function(response) {
    cb(response.data.branding)
  })
}

function getCurrentEvent(ssId, cb){
  $.get(`${APIURI}/event/player/${ssId}/currentEvent?apiKey=${APIKEY}`, function(response) {
    cb(response.data.currentEvent)
  })
}

function getCurrentLive(ssId, cb){
  $.get(`${APIURI}/v2/live/${ssId}?apiKey=${APIKEY}`, function(response) {
    cb(response)
  })
}

module.exports ={
  eventAuth: eventAuth,
  getVideosByCategory: getVideosByCategory,
  videoAuth: videoAuth,
  getBroadcaster: getBroadcaster,
  getMetaByBroadcastor:getMetaByBroadcastor,
  getMeta: getMeta,
  checkIsLocked: checkIsLocked,
  getCategories: getCategories,
  checkisBroadcasting: checkisBroadcasting,
  getUpcomingBroadcasts: getUpcomingBroadcasts,
  getVideos: getVideos,
  getVideo: getVideo,
  getBranding: getBranding,
  getCurrentEvent: getCurrentEvent,
  getCurrentLive: getCurrentLive
}



// WEBPACK FOOTER //
// ./src/api.js